import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

const SwiperCarousel = {
  init() {
    this.sliderArray = [];
    this.sliders = document.querySelectorAll(
      ".swiper-container:not(.swiper-container-initialized)"
    );

    if (this.sliders.length) {
      this.setOptions();
      this.initSliders();
      this.positionButtons();
    }
  },

  setOptions() {
    this.options = {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
      grabCursor: true,
      effect: "slide",
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      loopFillGroupWithBlank: true,
      // Pagination
      pagination: {
        clickable: true,
        type: "bullets",
      },
      navigation: {},
    };
  },

  setOptionPerSlider(slider) {
    const options = Object.assign({}, this.options);
    const dataset = slider.dataset;

    //Collect all data from element
    if (dataset) {
      for (const [key, value] of Object.entries(dataset)) {
        let formatValue =
          value === "false" ? false : value === "true" ? true : value;

        options[key] = Number.isNaN(Number(formatValue))
          ? formatValue
          : Number(formatValue);
      }
    }

    /**
     * Extra options depend on dataset
     */
    if (slider.dataset?.effect === "fade") {
      options.fadeEffect = {
        crossFade: true,
      };
      options.slidesPerView = 1;
    } else {
      options.effect = "slide";
    }

    //Fix for slider in slider nav
    let allowNav = false;
    let allowPag = false;

    [].slice.call(slider.children).forEach((child) => {
      if (child.classList.contains("swiper-button-next")) {
        allowNav = true;
      }

      if (child.classList.contains("swiper-pagination")) {
        allowPag = true;
      }

      if (child.classList.contains("swiper-navigation-wrapper")) {
        allowNav = true;
      }

      if (child.classList.contains("swiper__navigation")) {
        allowNav = true;
      }
    });

    /**
     * Set up pagination
     */

    if (allowPag) {
      options.pagination.el = slider.querySelector(".swiper-pagination")
        ? slider.querySelector(".swiper-pagination")
        : false;
    } else {
      options.pagination.el = false;
    }

    /**
     * Set up navigation
     */

    if (allowNav) {
      if (slider.querySelector(".swiper-button-next")) {
        options.navigation.nextEl = slider.querySelector(".swiper-button-next");
      } else {
        options.navigation.nextEl = false;
      }

      if (slider.querySelector(".swiper-button-prev")) {
        options.navigation.prevEl = slider.querySelector(".swiper-button-prev");
      } else {
        options.navigation.prevEl = false;
      }
    }

    /**
     * Set mobile slides per view
     */
    if (slider.dataset?.mobileSlidesPerView === "auto") {
      options.breakpoints = {
        1200: {
          slidesPerView: dataset?.slidesPerView ? dataset.slidesPerView : 1,
        },
      };

      options.slidesPerView = "auto";
    }

    /**
     * Additional buttons outside container
     */
    if (slider.dataset.button) {
      options.navigation.nextEl = document.querySelector(
        `#swiper-button-next-${slider.dataset.button}`
      );
      options.navigation.prevEl = document.querySelector(
        `#swiper-button-prev-${slider.dataset.button}`
      );
    }

    /** Autoplay */

    if (slider.dataset.autoplay) {
      options.autoplay = {
        delay: slider.dataset.autoplay,
        disableOnInteraction: false,
      };
    } else {
      delete options["autoplay"];
    }

    return options;
  },

  setOnlyMobile(slider, swiperElem, options) {
    if (slider.dataset?.desktop === "false") {
      swiperElem.destroy();
      let breakpoint = slider.dataset?.breakpointWidth || 767;

      if (document.querySelector("body").offsetWidth < breakpoint) {
        swiperElem = new Swiper(slider, options);
        this.resizeSliders();
        swiperElem.pagination.update();

        swiperElem.on("slideChange", function () {
          this.pagination.render();
          this.pagination.update();
        });
      }

      window.addEventListener("resize", () => {
        if (document.querySelector("body").offsetWidth < breakpoint) {
          if (slider.classList.contains(".swiper-container-initialized")) {
            if (typeof swiperElem.destroy === "function") {
              swiperElem?.destroy();
            }
          } else {
            const setOptions = this.setOptionPerSlider(slider);

            swiperElem = new Swiper(slider, setOptions);
            swiperElem.on("slideChange", function () {
              this.pagination.render();
              this.pagination.update();
            });
            this.resizeSliders();
          }
        } else if (typeof swiperElem.destroy === "function") {
          swiperElem?.destroy();
        }
      });
    }
  },

  initSliders() {
    this.sliders.forEach((slider) => {
      if (this.countSlides(slider) > 1) {
        const options = this.setOptionPerSlider(slider);

        let swiperElem = new Swiper(slider, options);
        this.onChange(swiperElem);
        this.onInit(swiperElem);
        this.sliderArray.push(swiperElem);

        this.setOnlyMobile(slider, swiperElem, options);
        window.dispatchEvent(new Event("resize"));
      } else {
        this.hideControllers(slider);
      }
    });

    this.resizeSliders();
  },

  onChange(swiper) {
    swiper.on("slideChangeTransitionEnd", function () {
      const swiperEl = swiper.$el[0];
      const activeSlide = swiperEl.querySelector(".swiper-slide-active");
      const activeVideo = activeSlide.querySelector("video");
      const allVideo = swiperEl.querySelectorAll("video");

      if (allVideo.length) {
        allVideo.forEach((video) => {
          video.pause();
          video.removeAttribute("controls");
        });
      }

      if (activeVideo) {
        $(activeSlide).find(".js-play-button--html-video").fadeIn(0);
        activeVideo.setAttribute("controls", true);
      }

      //iframe
      const iframes = swiperEl.querySelectorAll("iframe.js-ytEmbed");
      const activeiframe = activeSlide.querySelector(".js-ytEmbed");

      iframes.forEach((iframe) => {
        window[iframe.dataset.embed].pauseVideo();
      });

      if (activeiframe || activeVideo) {
        swiperEl.querySelector(".swiper-pagination").classList.add("pe-none");
      } else {
        swiperEl
          .querySelector(".swiper-pagination")
          .classList.remove("pe-none");
      }
    });
  },

  onInit(swiper) {
    swiper.on("init", function () {
      const swiperEl = swiper.$el[0];
      const activeSlide = swiperEl.querySelector(".swiper-slide-active");
      const activeVideo = activeSlide.querySelector("video");
      const allVideo = swiperEl.querySelectorAll("video");

      if (allVideo.length) {
        allVideo.forEach((video) => {
          video.pause();
        });
      }

      if (activeVideo) {
        activeVideo.play();
      }
    });

    //Randomize video id in swiper
    const videos = document.querySelectorAll(".swiper-slide .js-ytEmbed");
    if (videos.length) {
      videos.forEach((video, index) => {
        if (!video.classList.contains("js-id-changed")) {
          video.setAttribute("id", video.getAttribute("id") + `-${index}`);
          video.classList.add("js-id-changed");
        }
      });
    }
  },

  countSlides(slider) {
    const slides = slider.querySelectorAll(".swiper-slide");
    if (slider.querySelector(".js-dynamic-nearby-locations")) {
      return 2;
    }

    if (slides) {
      return slides.length;
    } else {
      return 0;
    }
  },

  hideControllers(slider) {
    const pagination = slider.querySelector(".swiper-pagination");
    const buttons = slider.querySelectorAll(".swiper-button");

    pagination && pagination.remove();

    if (buttons.length) {
      buttons.forEach((button) => {
        button.remove();
      });
    }
  },

  resizeSliders() {
    if (this.sliderArray.length) {
      this.sliderArray.forEach((slider) => {
        slider.update();
      });
    }
  },

  positionButtons() {
    this.positionButton();
    window.addEventListener("resize", () => {
      this.positionButton();
    });
  },

  positionButton() {
    const buttons = document.querySelectorAll(
      ".js-swiper-button-aim-for-image"
    );
    if (buttons) {
      buttons.forEach((button) => {
        const topElem = button.parentElement.querySelector(".js-top-elem");
        const top = topElem ? topElem.offsetHeight : 306;

        const offsetElem = button.parentElement.parentElement.querySelector(
          ".js-offset-elem"
        );
        const offset =
          offsetElem && topElem
            ? topElem.getBoundingClientRect().y -
              offsetElem.getBoundingClientRect().y
            : 0;

        button.style.top = `${top + offset}px`;
      });
    }
  },
};

SwiperCarousel.init();

const triggerTabList = document.querySelectorAll(".nav-tabs button");

//For slider preview

triggerTabList.forEach((elem) => {
  elem.addEventListener("click", (e) => {
    const id = e.currentTarget.dataset.bsTarget;

    e.currentTarget.parentNode.parentNode
      .querySelector(".nav-link.active")
      ?.classList?.remove("active");
    e.currentTarget.classList.add("active");

    const tab = document.querySelector(id);

    if (tab) {
      const parent = tab.parentNode;
      const currentActiveTab = parent.querySelector(".tab-pane.active");

      if (currentActiveTab) {
        currentActiveTab.classList.remove("show");
        currentActiveTab.classList.remove("active");
      }

      tab.classList.add("show");
      tab.classList.add("active");

      SwiperCarousel.resizeSliders();
    }
  });
});

export default SwiperCarousel;
